import React from 'react';
import '../../styles/MatchListItem.css'

export default function CancelButton({onClick}) {
  
	return (
    <button className='cancel-button' onClick={onClick}>
      ╳
    </button>
		);
}